import { __extends } from "tslib";
import React from 'react';
import classnames from 'classnames';
import { withTranslation } from 'react-i18next';
import DaEditorWrapper from '../../DaEditorWrapper/LoadableDaEditorWrapper';
import { EditorFlavourConfigs } from '../../DaEditorWrapper/config';
import { getFeature } from '../../DaEditorWrapper/Features';
import { WORD_COUNT_FEATURE } from '../../DaEditorWrapper/Features/wordCount';
import { MODAL_TAB_INDEX_BASE } from '../tabIndexes';
import LoadingIndicator from '../../LoadingIndicator';
import mergeTheme from '../../DaEditorWrapper/Themes/mergeTheme';
// Merge the text theme with the editor theme (content vs editor toolbars etc)
import textTheme from '../../DaEditorWrapper/Themes/Viewer/poll.scss';
import editorTheme from '../../DaEditorWrapper/Themes/Editor/poll.scss';
var pollTheme = mergeTheme(textTheme, editorTheme);
import s from './PollEditPopup.scss';
var MAX_CHARS = 70;
var Loader = function () { return React.createElement(LoadingIndicator, { className: s['loader'] }); };
var PollAnswer = /** @class */ (function (_super) {
    __extends(PollAnswer, _super);
    function PollAnswer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            toolbar: undefined,
            charCount: MAX_CHARS,
        };
        _this.handleEditorInit = function (toolbars) {
            if (!_this.state.toolbar && toolbars.FOOTER) {
                _this.setState({ toolbar: toolbars.FOOTER });
            }
        };
        _this.handleContentChange = function (rawContentState, editorContent, featuresData) {
            var editorData = {
                rawContentState: rawContentState,
                editorContent: editorContent,
                featuresData: featuresData,
            };
            _this.calculateCharsRemaining(featuresData);
            _this.props.handleEditorChange(editorData);
        };
        return _this;
    }
    PollAnswer.prototype.render = function () {
        var _a = this.props, className = _a.className, answer = _a.answer, index = _a.index;
        return (React.createElement("div", { className: classnames(editorTheme['answer-root'], 'da-editor-poll', className) },
            React.createElement(DaEditorWrapper, { loadingComponent: Loader, singleLine: true, plainText: true, charLimit: MAX_CHARS, key: answer.id, flavour: EditorFlavourConfigs.POLL_ANSWER, editorKey: "" + answer.id, placeholder: this.props.t("poll.fillTheOption." + (index + 1)), initialContent: answer.initialEditorData, onEditorInit: this.handleEditorInit, onContentChange: this.handleContentChange, tabIndex: MODAL_TAB_INDEX_BASE + 1 /* after question */ + this.props.index, theme: pollTheme }),
            this.renderToolbar()));
    };
    PollAnswer.prototype.renderToolbar = function () {
        var _a = this.state, toolbar = _a.toolbar, charCount = _a.charCount;
        if (!toolbar) {
            return;
        }
        var Toolbar = toolbar;
        // to avoid form submission
        var onClickPreventDefault = function (e) { return e.preventDefault(); };
        return (React.createElement("div", { className: editorTheme['toolbar'], onClick: onClickPreventDefault },
            React.createElement("span", { className: s['counter'] }, charCount),
            React.createElement(Toolbar, null)));
    };
    PollAnswer.prototype.calculateCharsRemaining = function (features) {
        var counts = getFeature(WORD_COUNT_FEATURE, features);
        if (!counts) {
            return;
        }
        this.setState({ charCount: MAX_CHARS - counts.data.chars });
    };
    return PollAnswer;
}(React.Component));
export { PollAnswer };
export default withTranslation()(PollAnswer);
//# sourceMappingURL=PollAnswer.js.map